import {DynamicData} from '../../../data/DynamicData';
import {StaticData} from '../../../data/StaticData';
import {SimpleRoundedRect} from '../SimpleRoundedRect';
import {Sprite, Text} from 'pixi.js';
import {TextFactory} from '../../../factories/TextFactory';
import {Pivot} from '../../../utils/Pivot';
import {HandEvents} from './HandEvents';

export class HandBackground extends Sprite
{
    private rect: SimpleRoundedRect;
    private handEmptyText: Text;
    private onHandHighlightedBindThis: (e: Event) => void;
    private onHandUnhighlightedBindThis: (e: Event) => void;
    private smallAlpha:number = .85;
    private bigAlpha:number = .95;

    constructor() {
        super();

        this.rect = new SimpleRoundedRect();
        this.addChild(this.rect).alpha = this.smallAlpha;

        this.handEmptyText = TextFactory.create('Your hand is empty');
        this.addChild(this.handEmptyText);

        Pivot.centerPivot(this.handEmptyText);
        this.buttonMode = true;

        this.onHandHighlightedBindThis = this.onHandHighlighted.bind(this);
        this.onHandUnhighlightedBindThis = this.onHandUnhighlighted.bind(this);
        addEventListener(HandEvents.HIGHLIGHT, this.onHandHighlightedBindThis);
        addEventListener(HandEvents.UNHIGHLIGHT, this.onHandUnhighlightedBindThis);
    }

    draw(width: number, height: number, color: number, radius: number, padding: number): void {
        this.rect.draw(width, height, color, radius, padding);
    }

    setEmptyTextVisible(visible: boolean) {
        this.handEmptyText.visible = visible;
    }

    resize(): void {
        this.handEmptyText.x = Math.floor(DynamicData.handSizes.width / 2);
        this.handEmptyText.y = Math.floor(DynamicData.handSizes.height / 2);
    }

    destroy(): void {
        removeEventListener(HandEvents.HIGHLIGHT, this.onHandHighlightedBindThis);
        removeEventListener(HandEvents.UNHIGHLIGHT, this.onHandUnhighlightedBindThis);

        delete this.onHandHighlightedBindThis;
        delete this.onHandUnhighlightedBindThis;
        super.destroy({children: true});
    }

    private onHandHighlighted(e: Event): void {
        e;
        this.rect.alpha = this.bigAlpha;
    }

    private onHandUnhighlighted(e: Event): void {
        e;
        this.rect.alpha = this.smallAlpha;
    }
}
